import { Vue, prop } from 'vue-class-component';

import WithBreadcrumbs from '@/components/with-breadcrumbs/with-breadcrumbs';
import { EntityRouteKey, isRouteLeafConfig, RavnurRouteLeafConfig } from '@/entity-route-config';
import { Breadcrumb } from '@/types/Breadcrumb';

class Props {
  leafTitle = prop({ default: '' });
}

export default class WithHierarchicalBreadcrumbs extends Vue.with(Props) {
  private get routeConfig(): Nullable<RavnurRouteLeafConfig> {
    const { config } = this.$route.meta;
    return isRouteLeafConfig(config) ? config : null;
  }

  get breadcrumbs(): Breadcrumb[] {
    const { leafTitle, routeConfig: config } = this;
    if (!config) {
      return [];
    }
    if (leafTitle) {
      const name = config.routes[EntityRouteKey.LIST];
      if (!name) {
        return [];
      }
      return [{ label: this.$t('common', config.tkey), to: { name } }, { label: leafTitle }];
    }
    return [{ label: leafTitle }];
  }

  render() {
    return <WithBreadcrumbs breadcrumbs={this.breadcrumbs} />;
  }
}
